import resourcePermission from './resourcePermission'
import validator from './validator'
import showLoading from './showLoading'

const install = Vue => {
  if (install.installed) return
  Vue.use(resourcePermission)
  Vue.use(validator)
  Vue.use(showLoading)
}
export default install



// WEBPACK FOOTER //
// ./src/mixins/index.js